import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { RetailersService, ShipmentsService, ShipmentRequest } from '@src/app/shared/backend/clients';
import { ComboData } from '@src/app/shared/components/comboData/comboData';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';
import { FilterOperator } from '@src/app/shared/enums/FilterOperator.enum';

@Component({
    selector: 'app-add-shipment',
    templateUrl: './add-shipment.component.html',
    styleUrl: './add-shipment.component.scss',
    host: {
        class: 'app-add-shipment'
    },
    standalone: false
})

export class AddShipmentComponent extends BaseViewComponent implements OnInit {

  combosData: { [key: string]: ComboData } = {
    'retailers': new ComboData(async (filter) => await firstValueFrom(this.retailersService.apiRetailersFilterComboPost(filter))),
    'origins': new ComboData(async (filter) => await firstValueFrom(this.retailersService.apiRetailersFilterComboPost(filter))),
    'destinations': new ComboData(async (filter) => await firstValueFrom(this.retailersService.apiRetailersFilterComboPost(filter)))
  }

  public shipmentForm: FormGroup = this.fb.group({
    reference: [null, [Validators.required, Validators.maxLength(50)]],
    retailerId: [[], [Validators.required]],
    originId: [[], [Validators.required]],
    destinationId: [[], [Validators.required]],
    comment: [null, [Validators.maxLength(255)]]
  });

  constructor(
    private router: Router,
    private retailersService: RetailersService,
    private shipmentsService: ShipmentsService,
    private fb: FormBuilder
  ) { super(); }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    await this.initCombosData();

    this.shipmentForm.controls['destinationId'].valueChanges.subscribe(async (destinationIds) => {
      const destinationId = destinationIds?.[0];

      if (!destinationId) {
        return;
      }
    });
  }


  private async initCombosData(): Promise<void> {
    await Promise.all([
      this.combosData['retailers'].getData(null, 1),
      this.combosData['origins'].getData(null, 1),
      this.combosData['destinations'].getData(null, 1),
    ]);
  }

  async onLazyLoadComboData(comboType: 'retailers' | 'origins' | 'destinations', event: any) {

    const search = event?.search?.trim() || null;
    const activePage = Math.max(1, event?.pageIndex ?? 1);

    await this.combosData[comboType].getData(search, activePage);
  }

  getComboTotalPages(comboType: 'retailers' | 'origins' | 'destinations'): number {
    const totalRecords = this.combosData[comboType]?.totalRecords ?? 0;
    const pageSize = Number(this.combosData[comboType]?.rowsPerPageOption) || 5;

    return Math.max(1, Math.ceil(totalRecords / pageSize));
  }

  async submitForm() {
    if (this.shipmentForm.valid) {
      const payload: ShipmentRequest = {
        name: this.shipmentForm.controls['reference'].value,
        originRetailerId: Number(this.shipmentForm.controls['originId'].value?.[0]),
        destinationRetailerId: Number(this.shipmentForm.controls['destinationId'].value?.[0]),
        retailerId: Number(this.shipmentForm.controls['retailerId'].value?.[0]),
        comment: this.shipmentForm.controls['comment'].value
      };

      var shipmentId = await firstValueFrom(this.shipmentsService.apiShipmentsCreatePost(payload));
      this.router.navigate(['/shipments', shipmentId], { replaceUrl: true });
    }
  }
}
